import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { Input, AddressFormatter, OpenHoursPicker } from "components";
import {
  Form,
  LineButton,
  Button,
  Hr,
  H2,
  H1,
  FlexRow,
  FlexRight,
} from "appStyles";
import Alert from "@material-ui/lab/Alert";

const BusinessForm = ({
  business: { name, locations, email },
  application,
  addLocation,
  addPhoneNumber,
  removeLocation,
  removePhoneNumber,
  updateBusiness,
  updateLocation,
  updatePhoneNumber,
  createBusinessApp,
  newBusiness,
  aboutUsProps,
  width,
}) => {
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState("");

  const handleCreateBusinessApp = () => {
    if (application.name === "") {
      setError("Please enter an app name");
      return;
    }
    if (disabled) return;
    setDisabled(true);
    // console.log("___ create biz app clicked");
    createBusinessApp();
  };

  return (
    <Form marginTop="1em" background="white" marginBottom="30px">
      <H1
        className="heading"
        lineHeight="35px"
        marginBottom="20px"
        style={{ letterSpacing: "2px", fontSize: "24px", textAlign: "left" }}
      >
        Business Information
      </H1>
      <Input
        field="Business Name"
        defaultValue={name}
        onChange={updateBusiness("name")}
        marginBottom="20px"
      />
      <Input
        field="Business Email"
        defaultValue={email}
        onChange={updateBusiness("email")}
        marginBottom="20px"
      />

      {locations &&
        locations.map((location, locationIdx) => {
          const { alias, address, hours, phoneNumbers } = location;

          return (
            <div key={locationIdx}>
              <H2>Location {locationIdx + 1}</H2>
              <a
                style={{
                  fontSize: "11px",
                  backgroundColor: "none",
                  width: "50%",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => removeLocation(locationIdx)}
              >
                Remove Location
              </a>
              <Input
                field="Location Name (i.e. Coffee Shop Main Street)"
                defaultValue={alias}
                onChange={updateLocation(locationIdx, "alias")}
                marginTop="20px"
                marginBottom="20px"
              />
              <Input
                field="Address"
                defaultValue={address}
                onChange={updateLocation(locationIdx, "address")}
                marginBottom="20px"
              />
              {/* <AddressFormatter 
              address={address}
              defaultValue={address}
              updateLocation={updateLocation(locationIdx, 'address')}/> */}
              <OpenHoursPicker
                hours={hours}
                defaultValue={hours}
                updateHours={updateLocation(locationIdx, "hours")}
              />

              {phoneNumbers &&
                phoneNumbers.map((phone, phoneIdx) => {
                  const { id, number, name } = phone;

                  return (
                    <div key={phoneIdx}>
                      <H2>Phone {phoneIdx + 1}</H2>
                      <a
                        style={{
                          fontSize: "11px",
                          backgroundColor: "none",
                          width: "50%",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          removePhoneNumber(
                            locationIdx,
                            phoneIdx,
                            id,
                            application.id
                          )
                        }
                      >
                        Remove Phone Number
                      </a>
                      <Input
                        field="Phone Type (i.e. Main, Mobile)"
                        defaultValue={name}
                        marginTop="20px"
                        marginBottom="20px"
                        onChange={updatePhoneNumber(
                          locationIdx,
                          phoneIdx,
                          "name"
                        )}
                      />
                      <Input
                        field="Phone Number"
                        type="tel"
                        defaultValue={number}
                        marginBottom="20px"
                        onChange={updatePhoneNumber(
                          locationIdx,
                          phoneIdx,
                          "number"
                        )}
                      />
                    </div>
                  );
                })}

              <Button
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  fontStyle: "normal",
                  fontStretch: "normal",
                  lineHeight: "normal",
                  letterSpacing: "normal",
                  textTransform: "none",
                  boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                  display: "inline-flex",
                  alignItems: "center",
                  borderRadius: "5.5px",
                }}
                background="#89D2D3"
                onClick={() => addPhoneNumber(locationIdx)}
              >
                Add Phone Number (optional)
              </Button>
            </div>
          );
        })}
      <Hr />
      <Button
        style={{
          fontSize: "15px",
          fontWeight: "bold",
          fontStyle: "normal",
          fontStretch: "normal",
          lineHeight: "normal",
          letterSpacing: "normal",
          textTransform: "none",
          boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          display: "inline-flex",
          alignItems: "center",
          borderRadius: "5.5px",
        }}
        background="#89D2D3"
        onClick={addLocation}
      >
        Add Location (optional)
      </Button>
      {error && <Alert severity="error">{error}</Alert>}
      {newBusiness && (
        <FlexRight>
          <Button
            style={{ backgroundColor: "#89D2D3" }}
            onClick={handleCreateBusinessApp}
            disabled={disabled}
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              fontStyle: "normal",
              fontStretch: "normal",
              lineHeight: "normal",
              letterSpacing: "normal",
              textTransform: "none",
              boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              display: "inline-flex",
              alignItems: "center",
              borderRadius: "5.5px",
            }}
          >
            Save & Continue
          </Button>
        </FlexRight>
      )}
    </Form>
  );
};

BusinessForm.propTypes = {
  application: PropTypes.object,
  addLocation: PropTypes.func,
  addPhoneNumber: PropTypes.func,
  removeLocation: PropTypes.func,
  removePhoneNumber: PropTypes.func,
  updateBusiness: PropTypes.func,
  updateLocation: PropTypes.func,
  updatePhoneNumber: PropTypes.func,
  aboutUsProps: PropTypes.object,
  width: PropTypes.any,
};

export default BusinessForm;
